<template>
  <div class="scroll-menu">
    <div class="menu-warp view-flex view-flex-vertical">
      <template>
        <component
          :is="currentTabComponent(menuItem)"
          v-for="(menuItem, levelIndex) in menuList"
          :key="levelIndex"
          :current="menuItem"
          :is-active="$route.path === menuItem.url"
          :is-last="menuItem.name === menuName"
        />
      </template>
    </div>
  </div>
</template>

<script>
import LevelOneItem from './levelOneMenu'
import LevelTwoItem from './levelTwoMenu'
import { filterHideMenu } from '@/utils/index'
export default {
  name: 'SpShopMenu',
  components: {
    LevelOneItem,
    LevelTwoItem
  },
  props: {
    menuList: {
      type: Array
    }
  },
  data () {
    return {
      menuName: ''
    }
  },
  watch: {
    menuList (val) {}
  },
  mounted () {
    console.log('SpShopMenu-menuList', this.menuList)
    const menuLength = (filterHideMenu(this.menuList) || []).length
    this.menuName = filterHideMenu(this.menuList)[menuLength - 1].name
  },
  methods: {
    currentTabComponent: function (item) {
      if (!item.children) {
        return LevelOneItem
      } else {
        return LevelTwoItem
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-warp {
  display: flex;
  background: #001529;
  padding-top: 43px;
  padding-bottom: 30px;
  box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.35);
  min-height: 100%;
  padding-bottom: 80px;
}
.scroll-menu {
  height: 100%;
  overflow-y: auto;
  margin-right: -15px;
}
</style>
